import React from 'react';
import DOMPurify from "dompurify";

export default function ChatBubble({
    username,
    date,
    message,
    step,
    me = false,
}) {
    return (
        <div className={`flex flex-col ${me ? "items-end" : "items-start"}`}>
            <span className="text-sm font-normal self-center mb-1">{date}</span>
            <span className={`text-sm font-semibold mb-1 ${me ? "self-end" : "self-start"}`}>{username}</span>
            <div
                className={`flex flex-col w-full max-w-80 md:max-w-[600px] leading-1.5 p-4 border-gray-200 
                ${me ? "bg-blue-500 text-white rounded-s-xl rounded-ee-xl" : "bg-gray-100 text-gray-900 rounded-e-xl rounded-es-xl"}`}
            >
                <div className={`flex ${me && "flex-row-reverse"}`}>
                    <span className="text-sm font-light italic">{step}</span>
                </div>
                <div className="text-sm py-2.5 chat-content break-words">
                    {message.trim().split('\n').map((line, index) => (
                        line && (
                            <React.Fragment key={index}>
                                <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(line.replaceAll('&nbsp;', ' ')) }} />
                            </React.Fragment>
                        )
                    ))}
                </div>
            </div>
        </div>
    );
};
